import { useCallback, useEffect, useRef, useState } from 'react'

import {
  type UnsubscribeOutcome,
  unsubscribeFromReminderEmails,
} from './service'

export type UnsubscribeState = UnsubscribeOutcome | 'working'

// Opening the link is the intent, so the page unsubscribes on load. Only the latest attempt may set the state.
export const useUnsubscribe = (token: string) => {
  const [state, setState] = useState<UnsubscribeState>('working')
  const latestAttempt = useRef(0)

  const unsubscribe = useCallback(() => {
    latestAttempt.current += 1
    const attempt = latestAttempt.current
    setState('working')
    unsubscribeFromReminderEmails(token).then((outcome) => {
      if (attempt === latestAttempt.current) setState(outcome)
    })
  }, [token])

  useEffect(unsubscribe, [unsubscribe])

  return { state, retry: unsubscribe }
}
